import { commitMutation, graphql } from 'react-relay';
import { Environment } from 'relay-runtime';
import { CartApplyPointsMutation } from './__generated__/CartApplyPointsMutation.graphql';

export const mutation = graphql`
  mutation CartApplyPointsMutation($input: CartApplyPointsMutationInput!) {
    cartApplyPoints(input: $input) {
      pointRedemptionCoupon {
        id
        amount
        rewardCouponCode
        couponId
      }
    }
  }
`;

interface CommitInput {
  environment: Environment;
  amount: number;
  yotpoRedemptionId: string;
  userId: string;
  onCompleted: any;
  onError: any;
}

function commit({
  environment,
  amount,
  userId,
  yotpoRedemptionId,
  onCompleted,
  onError,
}: CommitInput): Promise<void> {
  return new Promise((resolve, reject) => {
    return commitMutation<CartApplyPointsMutation>(environment, {
      mutation,
      variables: { input: { amount, yotpoRedemptionId, userId } },
      onCompleted: (...args) => {
        resolve(onCompleted(...args));
      },
      onError: error => {
        reject(onError(error));
      },
    });
  });
}

export default { commit };
